<div class="main-container">

  <div class="title">
    <span class="title-text">Operator Management</span>
    <p class="small-title">Central operators, their roles and access.</p>
  </div>

  <div class="header-actions">
    <input
      type="text"
      class="text-box-active search-input"
      placeholder="Search name, username, email, mobile or role"
      [(ngModel)]="searchText"
    />
    @if(canManage){
    <button type="button" class="ac-primary-btn" (click)="addOperator()">Add Operator</button>
    }
  </div>

  <div class="table-container">
    <table class="table">
      <thead class="table-head">
        <tr>
          <th>Name</th>
          <th>Username</th>
          <th>Email</th>
          <th>Mobile</th>
          <th>Role(s)</th>
          <th>Access</th>
          @if(canManage){ <th>Actions</th> }
        </tr>
      </thead>
      <tbody class="table-body">
        @for(op of filteredOperators; track op.sumId){
        <tr>
          <td>{{ op.fullName }}</td>
          <td>{{ op.userName }}</td>
          <td>{{ op.emailId || '-' }}</td>
          <td>{{ op.mobileNumber || '-' }}</td>
          <td>{{ op.roles || '-' }}</td>
          <td>{{ op.isRestricted ? 'Restricted' : 'Active' }}</td>
          @if(canManage){
          <td class="actions-cell">
            <button type="button" class="ac-secondary-small-btn" (click)="editOperator(op)">Edit</button>
            <button type="button" class="ac-secondary-small-btn" (click)="toggleRestricted(op)">
              {{ op.isRestricted ? 'Unrestrict' : 'Restrict' }}
            </button>
            <button type="button" class="ac-secondary-small-btn" (click)="managePermissions(op)">Permissions</button>
          </td>
          }
        </tr>
        }
        @if(!isLoading && filteredOperators.length === 0){
        <tr>
          <td [attr.colspan]="canManage ? 7 : 6" class="empty-row">No operators found.</td>
        </tr>
        }
      </tbody>
    </table>
  </div>

  <div class="activity-section">
    <div class="title">
      <span class="title-text">Operator activity</span>
      <p class="small-title">Everything the operators did in the chosen period, newest first.</p>
    </div>

    <div class="activity-filters">
      <div class="filter-field">
        <span class="filter-label">From</span>
        <input type="date" class="text-box-active" [(ngModel)]="activityFrom" />
      </div>
      <div class="filter-field">
        <span class="filter-label">To</span>
        <input type="date" class="text-box-active" [(ngModel)]="activityTo" />
      </div>
      <div class="filter-field">
        <span class="filter-label">Operator</span>
        <select class="text-box-active" [(ngModel)]="activityOperator">
          <option value="">All operators</option>
          @for(op of operators; track op.sumId){
          <option [value]="op.userName">{{ op.fullName }} ({{ op.userName }})</option>
          }
        </select>
      </div>
      @if(activityLoaded){
      <div class="filter-field">
        <span class="filter-label">Area</span>
        <select class="text-box-active" [(ngModel)]="activityCategory">
          <option value="">All areas</option>
          @for(c of activityCategories; track c){ <option [value]="c">{{ c }}</option> }
        </select>
      </div>
      <div class="filter-field">
        <span class="filter-label">Action</span>
        <select class="text-box-active" [(ngModel)]="activityAction">
          <option value="">All actions</option>
          @for(a of activityActions; track a){ <option [value]="a">{{ a }}</option> }
        </select>
      </div>
      }
      <button type="button" class="ac-primary-btn load-btn" (click)="loadActivity()">Load activity</button>
    </div>

    @if(activityLoaded){
    <div class="table-container activity-table">
      <table class="table">
        <thead class="table-head">
          <tr>
            <th>Time</th>
            <th>Operator</th>
            <th>Action</th>
            <th>Purpose</th>
            <th>Reference</th>
          </tr>
        </thead>
        <tbody class="table-body">
          @for(row of filteredActivity; track activityKey(row)){
          <tr>
            <td>{{ activityTime(row) }}</td>
            <td>{{ row.operator || '-' }}</td>
            <td>{{ row.action || '-' }}</td>
            <td>{{ row.purpose || '-' }}</td>
            <td>{{ activityRef(row) }}</td>
          </tr>
          }
          @if(!activityLoading && filteredActivity.length === 0){
          <tr>
            <td colspan="5" class="empty-row">No activity in this period.</td>
          </tr>
          }
        </tbody>
      </table>
    </div>
    }
  </div>

</div>

<app-loader [isLoading]="isLoading || activityLoading"></app-loader>
